/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

export function flattenQuery(query) {
  return Object.entries(query).reduce((flat, [sectionName, values]) => {
    if (sectionName === 'app' || sectionName === 'settings') {
      flat[sectionName] = values.edges.map(sectionData => sectionData.node)[0]
    } else if (values.edges) {
      flat[sectionName] = values.edges.map(sectionData => sectionData.node)
    } else {
      flat[sectionName] = values
    }
    return flat
  }, {})
}

export function convertCoordinates({ x, y, z }) {
  return {
    x,
    y: z,
    z: 1 / y === Infinity ? 0 : -y,
  }
}

export function mkEmptyData(ids) {
  const data = {
    allConfigs: [],
    allLocations: [],
    allSeasons: [],
    app: {},
    lawsonConversions: {},
    locations: {},
    plotTypes: [],
    sumerian: {},
  }

  ids.forEach(id => {
    data.locations[id] = mkEmptyLoc(id)
  })

  return data
}

export function mkEmptyLoc(id) {
  return {
    location: id,
    coordinates: {},
    summaries: {},
    plots: {},
    ratings: {},
  }
}

export function convertColor(hex) {
  const red = parseInt(hex.slice(1, 3), 16) / 255
  const blue = parseInt(hex.slice(3, 5), 16) / 255
  const green = parseInt(hex.slice(5, 7), 16) / 255
  const alpha = parseInt(hex.slice(7) || 'ff', 16) / 255
  return [red, blue, green, alpha]
}
